import { V2App } from '@wix/ambassador-app-service-webapp/types';
import { App } from '../../../../types/appManager';

export const normalizeApps = (data: V2App[]) =>
  data.reduce<App[]>((acc, it) => {
    if (!it.id) {
      return acc;
    }
    return [
      ...acc,
      {
        ...it,
        id: it.id,
      },
    ];
  }, []);
